class FaqSchema extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.buildSchema()
  }

  buildSchema () {
    const questions = this.els.question.elements
    const answers = this.els.answer.elements

    const mainEntity = [...questions].map((question, i) => ({
      '@type': 'Question',
      name: question.dataset.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answers[i].dataset.text,
      },
    }))

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity,
    }

    const scriptEl = document.createElement('script')
    scriptEl.type = 'application/ld+json'
    scriptEl.textContent = JSON.stringify(schema, null, 2)

    this.els.schema.element.replaceWith(scriptEl)
  }
}

if (!customElements.get('faq-schema')) {
  customElements.define('faq-schema', FaqSchema)
}
